/**
 * manage app state and allow those state persistent in storage
 */

class AppService {
    constructor() {
        this.appId = '3f';
    }

    // 通用获取序列化数据 storage可能取值'localStorage'、'sessionStorage'
    getSerialized(storage, key) {
        let actualKey = `${this.appId}.${key}`;
        let res;
        if (!window[storage]) {
            throw new Error(`${storage}不存在`);
        }
        try {
            res = JSON.parse(window[storage].getItem(actualKey));
        } catch (e) {
            res = null;
        }
        return res;
    }

    // 通用设置序列化数据 storage可能取值'localStorage'、'sessionStorage'
    setSerialized(storage, key, value) {
        let actualKey = `${this.appId}.${key}`;
        if (!window[storage]) {
            throw new Error(`${storage}不存在`);
        }
        try {
            window[storage].setItem(actualKey, JSON.stringify(value));
        } catch (e) {
            console.log(e, 'you may exit privacy mode');
        }
    }

    getSerializedValue(key) {
        return this.getSerialized('localStorage', key);
    }

    setSerializedValue(key, value) {
        this.setSerialized('localStorage', key, value);
    }

    getSessionSerializedValue(key) {
        return this.getSerialized('sessionStorage', key);
    }

    setSessionSerializedValue(key, value) {
        this.setSerialized('sessionStorage', key, value);
    }

    getObject(key) {
        let obj = this.getSerializedValue(key);
        if (angular.isString(obj)) {
            try {
                return JSON.parse(obj);
            } catch (e) {
                return obj;
            }
        }
        return obj;

        // let serializedState = this.getSerializedValue(key);
        // return serializedState ? JSON.parse(serializedState) : null;
    }

    getString(key) {
        return this.getSerializedValue(key);
    }

    getNumber(key) {
        return Number(this.getSerializedValue(key));
    }

    setObject(key, value) {
        // let serializedState = JSON.stringify(value);
        this.setSerializedValue(key, value);
    }

    setString(key, value) {
        this.setSerializedValue(key, value);
    }

    setNumber(key, value) {
        this.setSerializedValue(key, String(value));
    }

    clear() {
        let key;
        for (let i = 0; i < localStorage.length; i++) {
            key = localStorage.key(i);
            if (this._startsWith(key, `${this.appId}.`)) {
                localStorage.removeItem(key);
                i--;
            }
        }
    }

    _startsWith(subject, search) {
        return subject.substr(0, search.length) === search;
    }
}

export default AppService


// WEBPACK FOOTER //
// ./src/utils/AppService.js